import { ChangeEvent, useState } from 'react';
import { JobCountDetailResponse } from '@doda/api-client/aspida/@types';
import { findJobCount } from 'components/IndustryModal/logics/createIndustryDisplayData';
import { WorkingPlaceEnvironment } from 'types/kodawari';

/**
 * 会社・職場の環境に関するカスタムフック
 * @param InitialWorkplaceEnvironmentList
 * @returns 会社・職場の環境の値と更新する関数を含むオブジェクト
 */
export const useWorkplaceEnvironment = (
  InitialWorkplaceEnvironmentList: WorkingPlaceEnvironment[]
) => {
  const [WorkplaceEnvironmentList, setWorkplaceEnvironmentList] = useState<
    WorkingPlaceEnvironment[]
  >(InitialWorkplaceEnvironmentList);

  const selectedWorkplaceEnvironmentList = WorkplaceEnvironmentList.filter(
    ({ isChecked }) => isChecked
  ).map(({ value }) => value);

  // チェック状態更新処理
  const updateIsCheckedWorkplaceEnvironmentList = (
    event: ChangeEvent<HTMLInputElement>
  ) => {
    const checkedList = WorkplaceEnvironmentList.map((item) => {
      if (item.value !== event.target.value) return item;

      return {
        ...item,
        isChecked: event.target.checked,
      };
    });

    setWorkplaceEnvironmentList(checkedList);

    return checkedList
      .filter(({ isChecked }) => isChecked)
      .map(({ value }) => value);
  };

  // 求人件数更新処理
  const updateWorkplaceEnvironmentListJobCount = (
    workplaceEnvironmentList: JobCountDetailResponse[] | undefined
  ) => {
    setWorkplaceEnvironmentList((pre) =>
      pre.map((item) => ({
        ...item,
        jobCount: findJobCount(workplaceEnvironmentList, item.value),
      }))
    );
  };

  // チェック状態クリア処理
  const clearIsCheckedWorkplaceEnvironmentList = () => {
    const checkedList = WorkplaceEnvironmentList.map((item) => {
      return {
        ...item,
        isChecked: false,
      };
    });
    setWorkplaceEnvironmentList(checkedList);
  };

  return {
    WorkplaceEnvironmentList,
    selectedWorkplaceEnvironmentList,
    updateIsCheckedWorkplaceEnvironmentList,
    updateWorkplaceEnvironmentListJobCount,
    clearIsCheckedWorkplaceEnvironmentList,
  };
};
